import { appConfig } from 'brand-config';

/**
 * Whether this brand offers the staff "Send Invoice" billing action (#34203, #34419). On for the
 * mutual brands (CFM / Forreston / Oakwood), off for Branch. Read from the build-time brand config;
 * the action is additionally gated by the `canEditPolicies` permission where the flag is on.
 * Mirrors isDeleteSupportingDocumentsAllowed.
 */
export const isSendInvoiceAllowed = () => Boolean(appConfig?.featureFlags?.sendInvoice);
